<template>
  <div class="golf__inventory">
    <transition-group class="golf__inventory__list" name="fade--up__NOT" tag="ul">
      <li
        :key="item.id"
        class="golf__inventory__list__item ax--text_14Sm ax--text_16Md"
        v-for="item in filteredInventoryItems"
      >
        <div class="list__item--time">{{ item.time | formatTeeTime }}</div>

        <div class="list__item--players">{{ item.players }} {{ item.players === '1' ? 'Player' : 'Players' }}</div>

        <div class="list__item--price" :class="{ 'has-savings': item.savePercent !== 0 }">
          ${{ item.price }}
          <span class="savings" v-if="item.savePercent > 0">{{ item.savePercent | displayPercent }} Savings</span>
        </div>

        <div class="list__item--course">
          {{ item.course }}
          <span v-if="item.holes">{{ item.holes }} Holes</span>
        </div>

        <div class="list__item--reserve">
          <ax-button
            :border="true"
            button-type="secondary"
            :label="`Reserve - ${displayTeeTime(item.time)}`"
            v-on:click="selectItem(item)"
          ></ax-button>
        </div>
      </li>
      <li :key="101010101" class="golf__inventory__list__item" v-if="filteredInventoryItems.length === 0">
        <div class="list__item--no-items">No Tee Times Available</div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ProductInventory-golf',
  data() {
    return {
      PRICE_CLASSIFICATION: 'price-classification',
      HOLES_CLASSIFICATION: 'number-of-holes-classification',
      PLAYERS_CLASSIFICATION: 'number-of-players-classification',
      TIME_CLASSIFICATION: 'teetime-time-classification',
      COURSE_CLASSIFICATION: 'course-classification',
    }
  },
  model: {
    prop: 'inventoryItems',
    event: 'inventory-items-changed',
  },
  methods: {
    displayTeeTime(teeTime) {
      return this.$options.filters.formatTeeTime(teeTime)
    },
    getAttributeValue(item, key) {
      const attr = item.Attributes.find((attr) => attr.ProductAttributeType === key)
      if (attr) {
        return {
          name: attr.Name,
          baseValue: attr.BaseValue !== null ? parseInt(attr.BaseValue) : null,
          value: attr.Value !== null ? attr.Value : null,
          minValue: attr.MinValue !== null ? attr.MinValue : null,
          maxValue: attr.MaxValue !== null ? attr.MaxValue : null,
        }
      }

      return {
        name: null,
        value: null,
        minValue: null,
        maxValue: null,
      }
    },
    selectItem(item) {
      // TODO: Remove this temporary stripping of zero second times if needed
      const teeTime = item.time.replace(':00 ', ' ')

      const itemData = {
        time: teeTime,
        timeDisplay: this.$options.filters.formatTeeTime(item.time),
        holes: item.holes,
        price: item.price,
        basePrice: item.basePrice,
        maxPlayers: item.maxPlayers,
      }
      this.$emit('item-selected', itemData)
    },
    inventoryItemsChanged() {
      this.$emit('items-changed', this.inventoryItemsSummaryData)
    },
  },
  computed: {
    filteredInventoryItems() {
      const _self = this

      return this.mappedInventoryItems.filter((item) => {
        let filterItem = false

        const filterPlayerCount = isNaN(parseInt(_self.filterPlayers)) ? null : parseInt(_self.filterPlayers)

        if (
          item.timeValue < parseInt(_self.filterTimeBlock.minValue) ||
          item.timeValue > parseInt(_self.filterTimeBlock.maxValue)
        ) {
          filterItem = !filterItem ? true : filterItem
        }

        if (filterPlayerCount && (filterPlayerCount < item.minPlayers || filterPlayerCount > item.maxPlayers)) {
          filterItem = !filterItem ? true : filterItem
        }

        return !filterItem
      })
    },

    mappedInventoryItems() {
      return this.inventoryItems.map((item) => {
        const timeValue = this.getAttributeValue(item, this.TIME_CLASSIFICATION).value
        const timeBaseValue = this.getAttributeValue(item, this.TIME_CLASSIFICATION).baseValue
        const holesValue = this.getAttributeValue(item, this.HOLES_CLASSIFICATION).value
        const courseValue = this.getAttributeValue(item, this.COURSE_CLASSIFICATION).name
        const playersMinValue = this.getAttributeValue(item, this.PLAYERS_CLASSIFICATION).minValue
        const playersMaxValue = this.getAttributeValue(item, this.PLAYERS_CLASSIFICATION).maxValue
        const playersValue =
          playersMinValue !== playersMaxValue ? `${playersMinValue}-${playersMaxValue}` : playersMinValue

        return {
          id: item.InventoryItemId,
          time: timeValue || null,
          timeValue: timeBaseValue || null,
          price: item.Price || 0,
          saveAmount: item.SaveAmount || 0,
          savePercent: item.SavePercent || 0,
          basePrice: item.BasePrice || 0,
          holes: holesValue || null,
          course: courseValue || null,
          players: playersValue || null,
          minPlayers: playersMinValue || null,
          maxPlayers: playersMaxValue || null,
        }
      })
    },

    earliestReservationTime() {
      if (this.filteredInventoryItems && this.filteredInventoryItems.length > 1) {
        let earliestTime = this.filteredInventoryItems.reduce((prev, curr) => {
          const prevTime = prev.timeValue || prev
          // const comparePrev = Date.parse(`01/01/2000 ${prevTime}`)
          // const compareCurr = Date.parse(`01/01/2000 ${curr.time}`)

          // return comparePrev < compareCurr ? prevTime : curr.time;
          return prevTime < curr.timeValue ? prevTime : curr.timeValue
        })

        return earliestTime
      } else if (this.filteredInventoryItems && this.filteredInventoryItems.length == 1) {
        return this.filteredInventoryItems[0].time
      }

      return null
    },

    latestReservationTime() {
      if (this.filteredInventoryItems && this.filteredInventoryItems.length > 1) {
        let latestTime = this.filteredInventoryItems.reduce((prev, curr) => {
          const prevTime = prev.timeValue || prev
          // const comparePrev = Date.parse(`01/01/2000 ${prevTime}`)
          // const compareCurr = Date.parse(`01/01/2000 ${curr.time}`)

          //return comparePrev < compareCurr ? curr.time : prevTime;
          return prevTime < curr.timeValue ? curr.timeValue : prevTime
        })

        return latestTime
      } else if (this.filteredInventoryItems && this.filteredInventoryItems.length == 1) {
        return this.filteredInventoryItems[0].time
      }

      return null
    },

    lowestPrice() {
      if (this.mappedInventoryItems && this.mappedInventoryItems.length > 1) {
        let lowestPriceTime = this.mappedInventoryItems.reduce((prev, curr) => {
          return prev.price < curr.price ? prev : curr
        })

        return lowestPriceTime.price
      } else if (this.mappedInventoryItems && this.mappedInventoryItems.length == 1) {
        return this.mappedInventoryItems[0].price
      }

      return null
    },

    lowestPriceSaveAmount() {
      const _this = this

      if (this.lowestPrice) {
        const lowestPriceItem = this.mappedInventoryItems.find((item) => {
          return item.price === _this.lowestPrice
        })

        if (lowestPriceItem) {
          return lowestPriceItem.saveAmount
        }
      }

      return null
    },

    lowestPriceSavePercent() {
      const _this = this

      if (this.lowestPrice) {
        const lowestPriceItem = this.mappedInventoryItems.find((item) => {
          return item.price === _this.lowestPrice
        })

        if (lowestPriceItem) {
          return lowestPriceItem.savePercent
        }
      }

      return null
    },

    inventoryItemsSummaryData() {
      const summaryData = {
        count: this.filteredInventoryItems.length,
        lowestPrice: this.lowestPrice,
        lowestPriceSaveAmount: this.lowestPriceSaveAmount,
        lowestPriceSavePercent: this.lowestPriceSavePercent,
        earliestTime: this.earliestReservationTime,
        latestTime: this.latestReservationTime,
      }

      return summaryData
    },

    ...mapGetters({
      filterDate: 'filters/date',
      filterPlayers: 'filters/players',
      filterTimeBlock: 'filters/timeBlock',
    }),
  },
  watch: {
    filteredInventoryItems: {
      immediate: true,
      handler(toDate, fromDate) {
        this.inventoryItemsChanged()
      },
    },
  },
  filters: {
    displayPercent(percentValue) {
      return `${Math.round(percentValue)}%`
    },
    formatTeeTime(timeValue) {
      const momentTime = moment(`1/1/2000 ${timeValue}`).format('h:mm a')
      return momentTime
    },

    percentDisplay(percentValue) {},
  },
  props: {
    inventoryItems: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>
